import React from 'react';
import { Nullable } from 'global';
import { Info } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { FinancePaymentOption, SaleType } from 'modules/desking/shared';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { FormSectionHeader } from 'components/shared/FormSectionHeader/FormSectionHeader';

export const PaymentOptionsSection = ({
  selectedTerm,
  financePricing,
  onSelectOption,
  isCalculating = false,
}: {
  isCalculating?: boolean;
  selectedTerm: Nullable<string>;
  financePricing: Record<string, any>;
  onSelectOption?: (term: string) => void;
}) => {
  return (
    <Stack gap="1rem">
      <FormSectionHeader name="Menu Builder" value="builder" />

      <RenderWithCondition
        condition={isCalculating || !!Object.keys(financePricing).length}
        fallBack={
          <Stack gap="0.5rem" direction="row" alignItems="center">
            <Info color="primary" />

            <Typography component="span" variant="subtitle2" color="primary">
              Add Amount, Term and Buy Rate to render.
            </Typography>
          </Stack>
        }
      >
        <FinancePaymentOption
          selectedTerm={selectedTerm}
          isCalculating={isCalculating}
          saleType={SaleType.Financing}
          financePricing={financePricing}
          onSelectOption={onSelectOption}
        />
      </RenderWithCondition>
    </Stack>
  );
};
